import { z } from 'zod';

/**
 * Zod without its JIT, set before any schema exists: this module is the FIRST import of main.tsx,
 * because Zod reads the setting when each object schema is defined, at module load.
 *
 * With the JIT on, Zod probes `new Function("")` to find out whether it may compile parsers. Under
 * the app's Content-Security-Policy (no 'unsafe-eval', B-258) the probe is refused: Zod catches it
 * and falls back, but the browser still reports a `script-src` violation on every page load, which
 * would drown real ones and fire the CSP alarm for nothing. Our schemas are small; the JIT buys
 * nothing measurable here.
 */
z.config({ jitless: true });
